import { DesktopMenu } from '../App';

export default function EventDetails() {
  return (
    <>
      <DesktopMenu />

      <div className="text-secondary bg-linen font-archer font-semibold text-[20px]">
        <div className="max-w-[900px] mx-auto">
          {/* Ceremony details */}
          <div className="flex flex-col md:flex-row justify-center">
            <div className="p-8 md:pr-0 flex flex-col gap-4">
              <div>
                The ceremony will be held on <span className="bg-secondary/20 underline">Tuesday 13 October</span> at The Orangery, located at De Vere Tortworth Court.
                The address is <span className="bg-secondary/20">Tortworth, Wotton-under-Edge GL12 8HH, UK</span>.
              </div>
              <div>
                We kindly ask you to arrive around <span className="bg-secondary/20">10:15am-10:30am</span> to allow enough time to walk to The Orangery, sign our guest book, and settle in your seat.
              </div>
              <div className="font-bold underline">
              The ceremony will start promptly at 11am. Please silence and put away your devices as this will be an unplugged ceremony.
              </div>
              <div>
                **There is free parking on site, however, we are still figuring out alternative transportation and will provide more information closer to the day.
              </div>
              <div>
              After the ceremony, we invite you to stick around so we can take a few photos together and you can also explore the grounds yourself.
              </div>
            </div>
            <div className="relatitve w-full mx-auto md:mx-0 h-auto max-w-[177px] md:max-w-[347px]">
              <img src="/ceremony.png" alt="Ceremony" className="w-full h-full inset-0 object-contain" />
            </div>
          </div>

          {/* Reception details */}
          <div className="flex flex-col md:flex-row justify-center">
            <div className="p-8 md:pr-0 flex flex-col gap-4">
              <div>
              Once you've had your fill, please plan accordingly to travel into <span className="bg-secondary/20 font-bold">London</span> for the dinner reception. When traveling from Bristol to London, it will take approximately 2 and half hours by car or train.
              </div>
              <div>
                The dinner reception will be held at <span className="bg-secondary/20">Kasa & Kin</span>, located at <span className="bg-secondary/20">52-53 Poland St, London W1F 7NQ, United Kingdom</span>.
              </div>
              <div>
                We ask that you arrive around 6:45pm-6:50pm as <span className="bg-secondary/20">dinner will begin promptly at 7pm</span>.
              </div>
              <div>
                <div>You can expect a three-course meal:</div>
                <div className="pl-[16px]">
                  <div>Starters:</div>
                  <ul className="list-disc pl-[32px]">
                    <li>Wagyu Beef Lumpia</li>
                    <li>Fresh Vegetables Lumpia Sariwa</li>
                    <li>Pork Belly Sisig</li>
                  </ul>
                  <div>Mains:</div>
                  <ul className="list-disc pl-[32px]">
                    <li>Beef Kare Kare</li>
                    <li>Rib-eye Bistek Tagalog</li>
                    <li>Coconut Braised Cod</li>
                    <li>BBQ Pork Belly</li>
                  </ul>
                  <div className="text-[16px]"><i>*Mains served with garlic rice and fiesta mixed stir-fried noodles</i></div>
                  <div>Desserts:</div>
                  <ul className="list-disc pl-[32px]">
                    <li>Molten Ensaymada</li>
                    <li>Sans Rival</li>
                    <li>Ube Tasting Plate</li>
                    <li>Taho Ice Cream</li>
                  </ul>
                </div>
              </div>
            </div>
            <img src="/ramo.png" alt="ramo" className="w-full mx-auto md:mx-0 h-auto max-w-[164px] md:max-w-[297px] transform rotate-0 md:rotate-45 object-contain" />
          </div>
        </div>

        {/* What to wear */}
        <div className="max-w-[900px] mx-auto p-8">
          <div className="text-[36px] font-archer mb-2">What to Wear:</div>
          <div className="flex flex-col gap-4">
            <div>
            For the ceremony, cocktail or formal attire in shades of green is required. Please refer below for inspiration! For men, you may wear a full green suit or incorporate accents of green into your outfit.
            </div>
            <div className="px-4 md:px-8 py-4">
              <div className="grid grid-cols-3 rounded-xl overflow-hidden">
                <div className="bg-[#a5b67a] w-full h-[75px]"></div>
                <div className="bg-[#919e6a] w-full h-[75px]"></div>
                <div className="bg-[#7d885d] w-full h-[75px]"></div>
                <div className="bg-[#9b9941] w-full h-[75px]"></div>
                <div className="bg-[#878b3f] w-full h-[75px]"></div>
                <div className="bg-[#707f3f] w-full h-[75px]"></div>
                <div className="bg-[#5f6946] w-full h-[75px]"></div>
                <div className="bg-[#4e573c] w-full h-[75px]"></div>
                <div className="bg-[#3f4531] w-full h-[75px]"></div>
              </div>
            </div>
            <div>
              For the dinner reception, feel free to change into something less formal, dressy casual.
            </div>
            <div>
              If you have any questions regarding attire, please reach out to Raenna for guidance!
            </div>
          </div>
        </div>
      </div>

      <div className="pt-12 hidden md:block">
        <DesktopMenu />
      </div>
    </>
  );
};
